import React from 'react';

/**
 * Vorschau-Linien für Polygon im Aufbau.
 * Zeigt bestehende Verbindungen zwischen ausgewählten Punkten
 * und eine Preview-Linie zur aktuellen Mausposition.
 */
export function PendingLines({ pointIds, points, mousePosition, orthoMode }) {
  const linePoints = pointIds
    .map(pid => {
      // First try to find as building point ID
      const found = points.find(p => p.id === pid);
      if (found) return found;
      // Parse pl_x_y format (polyline tool coordinates)
      if (pid.startsWith('pl_')) {
        const parts = pid.split('_');
        if (parts.length >= 3) {
          return { x: parseFloat(parts[1]), y: parseFloat(parts[2]), z: 0 };
        }
      }
      return null;
    })
    .filter(Boolean);

  if (linePoints.length === 0) return null;

  // Letzer Punkt für Vorschau-Linie zur Maus
  const lastPoint = linePoints[linePoints.length - 1];

  // Ortho-Modus: Linie nur horizontal oder vertikal
  let previewEnd = mousePosition;
  if (orthoMode && lastPoint) {
    const dx = Math.abs(mousePosition.x - lastPoint.x);
    const dy = Math.abs(mousePosition.y - lastPoint.y);
    if (dx > dy) {
      previewEnd = { x: mousePosition.x, y: lastPoint.y };
    } else {
      previewEnd = { x: lastPoint.x, y: mousePosition.y };
    }
  }

  return (
    <group>
      {/* Bestehende Linien zwischen ausgewählten Punkten */}
      {linePoints.slice(0, -1).map((p, i) => {
        const next = linePoints[i + 1];
        return (
          <line key={`pending-${i}`}>
            <bufferGeometry>
              <bufferAttribute
                attach="attributes-position"
                count={2}
                array={new Float32Array([p.x, p.y, 3, next.x, next.y, 3])}
                itemSize={3}
              />
            </bufferGeometry>
            <lineBasicMaterial color="#22c55e" linewidth={2} />
          </line>
        );
      })}

      {/* Vorschau-Linie zur aktuellen Mausposition */}
      {lastPoint && (
        <line>
          <bufferGeometry>
            <bufferAttribute
              attach="attributes-position"
              count={2}
              array={new Float32Array([
                lastPoint.x, lastPoint.y, 3,
                previewEnd.x, previewEnd.y, 3
              ])}
              itemSize={3}
            />
          </bufferGeometry>
          <lineBasicMaterial color="#22c55e" linewidth={1} transparent opacity={0.5} />
        </line>
      )}
    </group>
  );
}

export default PendingLines;
